import QmAffix from './src/main'

/* istanbul ignore next */
QmAffix.install = function (Vue) {
  Vue.component(QmAffix.name, QmAffix)
}

export default QmAffix
